import { call, put, takeEvery } from "redux-saga/effects";
import {
  getPremiumPricingTiers,
  premiumInfoRequest,
  publicPremiumInfoRequest,
} from "../../api/premium";
import { premiumInfoActions } from "../../store/premium/actions";
import {
  PREMIUMINFO_REQUEST,
  PREMIUM_PRICING_TIERS_REQUEST,
  PUBLICPREMIUMINFO_REQUEST,
} from "../../constants/premium";

function* premiumInfoRequestSaga(action: any): any {
  const tipster_id = action.payload;
  try {
    const premiumInfo = yield call(premiumInfoRequest, tipster_id);

    yield put(premiumInfoActions.premiumInfoSuccessAction(premiumInfo));
  } catch (e: any) {
    yield put(premiumInfoActions.premiumInfoFailureAction(e));
  }
}
function* publicPremiumInfoRequestSaga(action: any): any {
  try {
    const premiumInfo = yield call(publicPremiumInfoRequest, action.payload);
    yield put(premiumInfoActions.premiumInfoSuccessAction(premiumInfo));
  } catch (e: any) {
    yield put(premiumInfoActions.premiumInfoFailureAction(e));
  }
}

function* premiumPricingTiersRequestSaga(): any {
  try {
    const pricingTiers = yield call(getPremiumPricingTiers);
    yield put(
      premiumInfoActions.premiumPricingTiersSuccessAction(pricingTiers)
    );
  } catch (e: any) {
    yield put(premiumInfoActions.premiumPricingTiersFailureAction(e));
  }
}

export function* premiumInfoSaga() {
  yield takeEvery(PREMIUMINFO_REQUEST, premiumInfoRequestSaga);
  yield takeEvery(
    PREMIUM_PRICING_TIERS_REQUEST,
    premiumPricingTiersRequestSaga
  );
}

export function* publicPremiumInfoSaga() {
  yield takeEvery(PUBLICPREMIUMINFO_REQUEST, publicPremiumInfoRequestSaga);
  yield takeEvery(
    PREMIUM_PRICING_TIERS_REQUEST,
    premiumPricingTiersRequestSaga
  );
}
